import type { BrandConfig } from './types';

export const wotuConfig: BrandConfig = {
  key: 'wotu',
  isDefault: false,
  subdomain: 'aifilm',
  logo: '/brands/wotu/logo.png',
  title: 'AI 实训 - 领先的AI模型与创作者社区',
  siteName: 'AI 实训',
  allowedCreationTabs: ['text', 'image', 'video', 'tools'],
  payment: {
    productName: 'AI实训平台付费服务协议',
    productNameKey: 'payment.wotuProductName',
  },
  agreementTabs: [
    { key: 'user-agreement', label: 'AI实训平台付费协议', labelKey: 'agreement.tabWotuPayment' },
    { key: 'ricegrain-rules', label: '米粒值规则说明', labelKey: 'agreement.tabRiceGrain' },
    { key: 'privacy-policy', label: '用户协议及隐私政策', labelKey: 'agreement.tabPrivacy' },
    { key: 'enterprise-service-agreement', label: '企业服务协议', labelKey: 'agreement.tabEnterprise' },
  ],
  hiddenUserMenuItems: ['feedback', 'profile', 'agreements'],
  hiddenSidebarItems: ['invite'],
  logoDisplay: {
    mode: 'text',
    text: 'AI 实训',
    showGlow: true,
    textStyle: { fontSize: '18px', fontWeight: '500' },
  },
};
